import ChartBarIcon from '@atlaskit/icon/core/chart-bar';

import { renderIconTile } from './utils';

const ChartBarIconWithColor = renderIconTile(ChartBarIcon, 'purpleBold');
ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';

export default ChartBarIconWithColor;
